'use strict';

var React = require('react');

var SvgPagePlusMajor = function SvgPagePlusMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.5 5.75c0-.69.56-1.25 1.25-1.25h2.75v3.25c0 .966.784 1.75 1.75 1.75h3.25v1.25a.75.75 0 0 0 1.5 0v-2a.75.75 0 0 0-.22-.53l-5-5a.75.75 0 0 0-.53-.22h-3.5a2.75 2.75 0 0 0-2.75 2.75v8.5a2.75 2.75 0 0 0 2.75 2.75h4.25a.75.75 0 0 0 0-1.5h-4.25c-.69 0-1.25-.56-1.25-1.25v-8.5Zm7.94 2.25-2.44-2.44v2.19c0 .138.112.25.25.25h2.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5 13.25a.75.75 0 0 1 1.5 0v1.25h1.25a.75.75 0 0 1 0 1.5h-1.25v1.25a.75.75 0 0 1-1.5 0v-1.25h-1.25a.75.75 0 0 1 0-1.5h1.25v-1.25Z"
  }));
};
SvgPagePlusMajor.displayName = "PagePlusMajor";

exports.SvgPagePlusMajor = SvgPagePlusMajor;
